import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M13 18l6 -6","key":"svg-1"}],["path",{"d":"M13 6l6 6","key":"svg-2"}]]

const IconArrowRight = createReactComponent('outline', 'arrow-right', 'ArrowRight', __iconNode);

export default IconArrowRight;